import { useState, useEffect } from 'react';

const useViewPort = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(1); // Default for larger screens
  const [viewports, setViewports] = useState("");

  useEffect(() => {
    const updateImageIndex = () => {
      if (window.matchMedia("(max-width: 767px)").matches) {
        setCurrentImageIndex(0); // For mobiles
        setViewports("mobile");
      } else if (window.matchMedia("(max-width: 1023px)").matches) {
        setCurrentImageIndex(1); // For tablets
        setViewports("tablet");
      } else if (window.matchMedia("(max-width: 1279px)").matches) {
        setCurrentImageIndex(1); // For laptops
        setViewports("laptop");
      } else if (window.matchMedia("(max-width: 1919px)").matches) {
        setCurrentImageIndex(2); // For desktops
        setViewports("desktop");
      } else {
        setCurrentImageIndex(2); // Large TV screens
        setViewports("large-screen");
      }
    };

    updateImageIndex(); // Set correct index initially
    window.addEventListener("resize", updateImageIndex); // Update on resize

    return () => window.removeEventListener("resize", updateImageIndex); // Cleanup on unmount
  }, []);

  return { currentImageIndex, viewports };
};

export default useViewPort;
